// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"oi_a bhl_a bhl_x","FilterForm__vgroup":"oi_b bhl_sv"};